import { Injectable } from "@angular/core";
import { map, Observable, of, tap } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CMS_END_POINTS } from 'src/app/const/api';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MultimediaService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getMultimediaLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_LANDING, {
      params: body
    });
  }


  getFahesMultimediaLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_MULTIMEDIA_LANDING, {
      params: body
    });
  }
  getQJETMultimediaLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_MULTIMEDIA_LANDING, {
      params: body
    });
  }

  getNewsLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NEWS_LANDING, {
      params: body
    });
  }

  getFahesNewsLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_NEWS_LANDING, {
      params: body
    });
  }
  getQjetNewsLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_NEWS_LANDING, {
      params: body
    });
  }
  getFahesServiceBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHEX_SERVICE_BANNERS, {
      params: body
    });
  }
  getQjetServiceBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_SERVICE_BANNERS, {
      params: body
    });
  }

  getNewsBanner(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NEWS_BANNER, {
      params: body
    });
  }
  getEventsBanner(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENTS_BANNER, {
      params: body
    });
  }

  getNewsListing(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NEWS_LISTING, {
      params: body
    });
  }

  getNewsDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NEWS_DETAIL, {
      params: body
    });
  }

  getFahesNewsDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_NEWS_DETAILS, {
      params: body
    });
  }
  getQjetNewsDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_NEWS_DETAILS, {
      params: body
    });
  }

  getFahesEventDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_EVENT_DETAILS, {
      params: body
    });
  }
  getQjetEventDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_EVENT_DETAILS, {
      params: body
    });
  }
  getCheckPaid(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.GET_CHECK_PAID, {
      params: body
    });
  }

  getEventDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENT_DETAIL, {
      params: body
    });
  }
  GetLubricantsDetailsByLubricantCategoryID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetLubricantsDetailsByLubricantCategoryID, {
      params: body
    });
  }
  GetVideoItems(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_VIDEOS_ITEM, {
      params: body
    });
  }
  GetImagesItems(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_IMAGES_ITEM, {
      params: body
    });
  }

  GetLubricantCategoryByURL(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetLubricantCategoryByURL, {
      params: body
    });
  }

  GetLubricantsDetailsImagesByLubricantsDetailsId(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetLubricantsDetailsImagesByLubricantsDetailsId, {
      params: body
    });
  }

  getAutoCareSubService(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_AUTO_CARE_SUB_SERVICE, {
      params: body
    });
  }

  getPromotionDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTION_DETAIL, {
      params: body
    });
  }

  getTransactionByID(body: any = {}, isFahesPage: boolean = false): Observable<any> {
    return this.httpClient.get<any>(isFahesPage ? CMS_END_POINTS.getTransactionByID_FAHES : CMS_END_POINTS.getTransactionByID, {
      params: body
    });
  }

  getTransactionByIDInspection(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getInspectionFull, {
      params: body
    });
  }

  getCodeOfEthics(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CODE_OF_ETHICS, {
      params: body
    });
  }
  getMediaCenterNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MEDIA_CENTER_NEWS, {
      params: body
    });
  }
  getFahesMultimediaBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MEDIA_CENTER_MULTIMEDIA_FAHES, {
      params: body
    });
  }
  getQjetMultimediaBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MEDIA_CENTER_MULTIMEDIA_QJET, {
      params: body
    });
  }
  getFahesAboutUs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_ABOUT_US, {
      params: body
    });
  }
  getQJETAboutUs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_ABOUT_US, {
      params: body
    });
  }
  getFahesAboutUsBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_ABOUT_US_BULLETS, {
      params: body
    });
  }
  getQjetAboutUsBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_ABOUT_US_BULLETS, {
      params: body
    });
  }
  getFahesContactUsBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_CONTACT_US_BULLETS, {
      params: body
    });
  }
  getFahesContactUs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_CONTACT_US, {
      params: body
    });
  }

  getFahesHomePageMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_HOME, {
      params: body
    });
  }

  getQJETHomePageMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_META_HOME, {
      params: body
    });
  }


  getFahesHomePageNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_NEWS_HOME, {
      params: body
    });
  }

  getFahesHomePageContent(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_HOME_CONTENT_PAGES, {
      params: body
    });
  }

  getFahesContactUsDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_CONTACT_US_OFFICE, {
      params: body
    });
  }
  getContactUs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTACT_US, {
      params: body
    });
  }
  getContactUsQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTACT_US_QJET, {
      params: body
    });
  }
  getContactUsBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTACT_US_BULLETS, {
      params: body
    });
  }
  getContactUsDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTACT_US_OFFICE, {
      params: body
    });
  }
  getContactUsDetailsQJET(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTACT_US_OFFICE_QJET, {
      params: body
    });
  }
  getFahesWhatWeDo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_WHAT_WE_DO, {
      params: body
    });
  }
  getFahesWhoWeAre(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_WHO_WE_ARE, {
      params: body
    });
  }
  getSystemsAndRegulations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SYSTEMS_AND_REGULATIONS, {
      params: body
    });
  }
  getSystemsAndRegulationsDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SYSTEMS_AND_REGULATIONS_DETAILS, {
      params: body
    });
  }
  getWoqodeInfo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_INFO, {
      params: body
    });
  }
  getWoqodeTopup(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_TOPUP, {
      params: body
    });
  }
  getWoqodeBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_BULLETS, {
      params: body
    });
  }
  getWoqodepriceI(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_PRICE, {
      params: body
    });
  }
  getWoqodepriceC(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_CORPORATE_PRICE, {
      params: body
    });
  }
  getFahesFaq(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_FAQS, {
      params: body
    });
  }
  getQjetFaq(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_FAQS, {
      params: body
    });
  }
  getFahesTrafficService(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_TRAFFIC_SERVICE, {
      params: body
    });
  }
  getSustainabillityLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUSTAINABILITY_LANDING, {
      params: body
    });
  }
  getSustainabillityBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUSTAINABILITY_BANNERS, {
      params: body
    });
  }
  getFeedbackLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_LANDING, {
      params: body
    });
  }
  getSustainabillityBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUSTAINABILITY_BULLETS, {
      params: body
    });
  }
  // getCareerFaqsHomePage(body: any = {}): Observable<any> {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_FAQ_HOMEPAGE, {
  //     params: body
  //   });
  // }
  getFahesSustainabilty(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_SUSTAINABLITY, {
      params: body
    });
  }
  getQJETSustainabilty(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_SUSTAINABLITY, {
      params: body
    });
  }
  getQJETCSR(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_CSR, {
      params: body
    });
  }
  getCSRData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CSR_DATA, {
      params: body
    });
  }
  getFahesSustainabiltyAreaTwo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_SUSTAINABLITY_AREA_TWO, {
      params: body
    });
  }
  getQJETSustainabiltyAreaTwo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_SUSTAINABLITY_AREA_TWO, {
      params: body
    });
  }
  getQJETCSRAreaTwo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_CSR_AREA_TWO, {
      params: body
    });
  }
  getFahesSustainabillityBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_SUSTAINABLITY_BULLETS, {
      params: body
    });
  }
  getQJETSustainabillityBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_SUSTAINABLITY_BULLETS, {
      params: body
    });
  }
  getQJETCSRBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_CSR_BULLETS, {
      params: body
    });
  }
  getFahesSustainabillityFour(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_SUSTAINABLITY_AREA_FOUR, {
      params: body
    });
  }
  getQJETSustainabillityFour(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_SUSTAINABLITY_AREA_FOUR, {
      params: body
    });
  }
  getQJETCSRFour(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_CSR_AREA_FOUR, {
      params: body
    });
  }
  getQjetCSRBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_CSR_BANNER, {
      params: body
    });
  }
  getCareerDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_DETAIL, {
      params: body
    });
  }
  getCareerDetailByUrl(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_DETAIL_BYURL, {
      params: body
    });
  }
  getTenderDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TENDER_DETAIL, {
      params: body
    });
  }
  getProductDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PRODUCT_DETAIL, {
      params: body
    });
  }
  getProductBulletsDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PRODUCT_BULLETS_DETAIL, {
      params: body
    });
  }
  getServices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES, {
      params: body
    });
  }
  getServicesQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES_QJET, {
      params: body
    });
  }
  getServicesData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES_DATA, {
      params: body
    });
  }
  getServicesDataQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES_DATA_QJET, {
      params: body
    });
  }
  getCareerHome(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_HOMEPAGE, {
      params: body
    });
  }
  getCareerBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_BANNERS, {
      params: body
    });
  }
  getWOQODEBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_BANNERS, {
      params: body
    });
  }
  WoqodePageInfo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.WoqodePageInfo, {
      params: body
    });
  }

  getProductServiceBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PRODUCTS_SERVICES_BANNERS, {
      params: body
    });
  }
  getLubricuntBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANTS_BANNERS, {
      params: body
    });
  }
  getCareerTitle(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LANDING_CONTENT_BOX, {
      params: body
    });
  }
  getCareerLandingAreaOne(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LANDING_AREA_ONE, {
      params: body
    });
  }
  getCareerLandingAreaTwo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LANDING_AREA_TWO, {
      params: body
    });
  }
  getCareerLandingAreaThree(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LANDING_AREA_THREE, {
      params: body
    });
  }
  getCareerFaqs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_FAQS, {
      params: body
    });
  }
  getCareerContentBox(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LANDING_CONTENT_BOX, {
      params: body
    });
  }
  getBulletsCodeOf(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BULLETS_CODE_OF_ETHIC, {
      params: body
    });
  }
  getCareerJobs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_JOBS, {
      params: body
    });
  }
  getShafaf(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SHAFAF_META, {
      params: body
    });
  }
  getFeaturedShafaf(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SHAFAF_FEATURED, {
      params: body
    });
  }
  getFeaturedRates(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SHAFAF_RATES, {
      params: body
    });
  }
  getFeaturedAccessories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SHAFAF_ACCESSORIES, {
      params: body
    });
  }
  getSuperMarketMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUPER_MARKET_DATA, {
      params: body
    });
  }
  getSuperMarketReatilMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUPER_MARKET_RETAILERS_DATA, {
      params: body
    });
  }
  getFeedbackCategoryFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_FAHES_CATEGORY, {
      params: body
    });
  }
  getFeedbackCategoryFahesNew(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_FAHES_CATEGORY_NEW, {
      params: body
    });
  }
  getServicesAPC(isAPCPage: boolean, body: any = {}): Observable<any> {
    return this.httpClient.get<any>(isAPCPage ? CMS_END_POINTS.GET_SERVICE_APC : CMS_END_POINTS.GetWoqodEServicesPagination, {
      params: body
    });
  }

  getServiceByID(isAPCPage: boolean, body: any = {}){
    return this.httpClient.get<any>(isAPCPage ? CMS_END_POINTS.GET_SERVICE_APCBYID : CMS_END_POINTS.GetWoqodEServicesPaginationBYID, {
      params: body
    }).toPromise();
  }  

  getSubServices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetSubServices, {
      params: body
    });
  }

  getFeedbackSource(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_SOURCE, {
      params: body
    });
  }

  getCareersFieldOfStudy(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREERS_FIELS_OF_STUDY, {
      params: body
    });
  }

  getYearsofExperience(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_YEARS_OF_EXPERIANCE, {
      params: body
    });
  }

  getCurrentEmploymentStatus(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CURRENT_EMPLOYMENT_STATUS, {
      params: body
    });
  }

  getEducationalDegree(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EDUCATIONAL_DEGREE, {
      params: body
    });
  }
  getMandtory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MANDTORY, {
      params: body
    });
  }

  getNationality(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NATIONALITY, {
      params: body
    });
  }

  getNationalityBene(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_NATIONALITY_BENE, {
      params: body
    });
  }

  getRetailSetting(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RETAIL_SETTING, {
      params: body
    });
  }  

  getRelativeType(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATIVE_TYPE, {
      params: body
    });
  }

  logout(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.LOGOUT, {
      params: body
    });
  }

  getProductCategory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CATEGRIES, {
      params: body
    });
  }

  getPreviousEmp(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PREVIOUS_EMP, {
      params: body
    });
  }

  getFeedbackSectorsFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_FAHES_SECTORS, {
      params: body
    });
  }
  getFeedbackType(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_TYPE, {
      params: body
    });
  }
  getFeedbackDepartment(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_DEPARTMENT, {
      params: body
    });
  }

  getContentPageByURL(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_BY_URL, {
      params: body
    });
  }
  getCareerContentBannerPageByID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_BANNERS_BY_URL, {
      params: body
    });
  }
  getTenderContentBannerPageByID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TENDER_BANNERS_BY_URL, {
      params: body
    });
  }
  getGenralContentBannerPageByID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_BANNERS_BY_URL, {
      params: body
    });
  }

  getContentPageByURLCSR(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_BY_URL_CSR, {
      params: body
    });
  }
  getContentPageByURLFAHES(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_BY_URL_FAHES, {
      params: body
    });
  }
  getContentPageByURLQJET(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_BY_URL_QJET, {
      params: body
    });
  }

  getServiceDetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES_DETAIL_PAGE, {
      params: body
    });
  }
  getServiceDetailQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICES_DETAIL_PAGE_QJET, {
      params: body
    });
  }
  getTenderBecomeASupplier(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TENDER_SUPPLIER, {
      params: body
    });
  }
  getAutoCareSupplier(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_AUTO_CARE_SUPPLIER, {
      params: body
    });
  }

  getbwwoqoodSupplier(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WITH_WOQOOD_SUPPLIER, {
      params: body
    });
  }


  getPaymentData(body: any = {}, site = '', isPToken = false): Observable<any> {
    // isPToken
    const withoutPtoken = site === 'woqod' ? CMS_END_POINTS.GET_PAYMENT_DATA : CMS_END_POINTS.GET_PAYMENT_DATA_FAHES;
    const withPtoken = site === 'woqod' ? CMS_END_POINTS.GET_PAYMENT_DATA_PTOKEN : CMS_END_POINTS.GET_PAYMENT_DATA_FAHES_PTOKEN;
    return this.httpClient.get<any>(isPToken ? withPtoken : withoutPtoken, {
      params: body
    });
  }

  getPaymentDataSaveCard(body: any = {}, site = ''): Observable<any> {
    return this.httpClient.get<any>(site === 'woqod' ? CMS_END_POINTS.GET_PAYMENT_DATA_SAVE_CARD : CMS_END_POINTS.GET_PAYMENT_DATA_FAHES_SAVE_CARD, {
      params: body
    });
  }

  getPaymentDataQP(body: any = {}, site = ''): Observable<any> {
    return this.httpClient.get<any>(site === 'woqod' ? CMS_END_POINTS.GET_PAYMENT_DATA_QP : CMS_END_POINTS.GET_PAYMENT_DATA_QP_FAHES, {
      params: body
    });
  }

  getContentPageByIDetaData(pageID: string): Observable<any> {
    const endpointMapping: { [key: string]: string } = {
      'environmental-management': CMS_END_POINTS.GET_ENVIRONMENTAL_MANAGMENT,
      'petrol-stations-safety-instructions': CMS_END_POINTS.GET_PETROL_STATION_SAFETY_INSTRUCTIONS,
      'integrated-management-system': CMS_END_POINTS.GET_INTEGRATED_MANAGMENT_SYSTEM,
      'awareness-campaign': CMS_END_POINTS.GET_AWARENESS_CAMPAIGN,
      'brand-guidelines': CMS_END_POINTS.GET_BRAND_GUIDELINES,
      'company-profile': CMS_END_POINTS.GET_COMPANY_PROFILE,
      'health-and-safety': CMS_END_POINTS.GET_HEALTH_AND_SAFETY,
      'promotions': CMS_END_POINTS.GET_PROMOTIONS_META,
      'why-woqod': CMS_END_POINTS.GET_WHY_WOQOD,
      'careers': CMS_END_POINTS.GET_CAREERS,
      'what-we-do': CMS_END_POINTS.GET_WHAT_WE_DO,
      'equality-diversity-inclusion': CMS_END_POINTS.GET_EQUALITY_DIVERSITY_INCLUSION,
      'what-we-look-for': CMS_END_POINTS.GET_WHAT_WE_LOOK_FOR,
      'interview-tips': CMS_END_POINTS.GET_INTERVIEW_TIPS,
      'get-noticed': CMS_END_POINTS.GET_NOTICED,
      'talent-development-strategy': CMS_END_POINTS.GET_TALENT_DEVELOPMENT_STRATEGY,
      'qatarization': CMS_END_POINTS.GET_QATARRAIZATION,
      'life-at-woqod': CMS_END_POINTS.GET_LIFE_AT_WOQOD,
      'woqod-culture': CMS_END_POINTS.GET_WOQOD_CULTURE,
      'benefits': CMS_END_POINTS.GET_BENIFITS,
      'top-ten-reason-to-choose-woqod': CMS_END_POINTS.GET_TOP_TEN_REASON_TO_CHOOSE_WOQOD,
      'meet-our-team': CMS_END_POINTS.GET_MEET_OUR_TEAM,
      'five-ways-to-help-you-find-the-right-career-path': CMS_END_POINTS.GET_FIVE_WAY_TO_HELP_YOU_FIND_THE_RIGHT_CAREER_PATH,
      'woqode-tag': CMS_END_POINTS.GET_WOQODE_TAG,
      'retail': CMS_END_POINTS.GET_RETAIL,
      'auto-care-service': CMS_END_POINTS.GET_AUTO_CARE_SERVICE,
      'business-with-woqod': CMS_END_POINTS.GET_BUSINESS_WITH_WOQOD,
      'sustainability': CMS_END_POINTS.GET_SUSTAINABILITY,
      'our-story': CMS_END_POINTS.GET_OUR_STORY,
      'student-opportunties': CMS_END_POINTS.GET_STUDENT_OPPORTUNITIES,
      'vision-mission-values': CMS_END_POINTS.GET_VISION_MISSION_VALUES,
      'kenar-landing': CMS_END_POINTS.GET_KENAR_LANDING,
      'sidra': CMS_END_POINTS.GET_SIDRA,
      'tender-landing': CMS_END_POINTS.GET_TINDER_LANDING,
      'fahes-faq': CMS_END_POINTS.GET_FAHES_FAQ_LANDING,
      'faq': CMS_END_POINTS.GET_FAQ_LANDING,
      'FAQ_QJET': CMS_END_POINTS.GET_FAQ_LANDING_QJET,
    };
    const API_PATH = endpointMapping[pageID];
    return this.httpClient.get<any>(API_PATH);
  }

  getEventsListing(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENTS_LISTING, {
      params: body
    });
  }

  getCareersCarouselData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREERS_CAROUSEL_DATA, {
      params: body
    });
  }

  getWoqodeTagCarouselData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_TAG_CAROUSEL_DATA, {
      params: body
    });
  }
  getWoqodePricesCorporate(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_PRICES_DATA, {
      params: body
    });
  }
  getWoqodePricesIndividual(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_PRICES_INDIVIDUAL_DATA, {
      params: body
    });
  }

  getSocialLinks(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SOCIAL_LINKS, {
      params: body
    });
  }
  getSocialLinksFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SOCIAL_LINKS_FAHES, {
      params: body
    });
  }

  getSocialLinksQJET(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SOCIAL_LINKS_QJET, {
      params: body
    });
  }

  getBusinessWithWoqodImages(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BUSINESS_WITH_WOQOD_IMAGES, {
      params: body
    });
  }

  getFahesFAQCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_FAQ_CATEGORIES, {
      params: body
    });
  }
  getQJETFAQCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_FAQ_CATEGORIES, {
      params: body
    });
  }

  getFAQCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAQ_CATEGORIES_FILTER, {
      params: body
    });
  }
  getFAQListCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAQ_CATEGORIES_FILTER_LIST, {
      params: body
    });
  }

  getSustainabilityEvents(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUSTAINABILITY_EVENTS, {
      params: body
    });
  }
  getSustainabilityNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUSTAINABILITY_NEWS, {
      params: body
    });
  }

  getRetailCarouselData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RETAIL_CAROUSEL_DATA, {
      params: body
    });
  }

  getPromotionCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTION_CATEGORIES, {
      params: body
    });
  }
  getPromotionBanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTIONS_BANNERS, {
      params: body
    });
  }

  getEventCategories(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENT_CATEGORIES, {
      params: body
    });
  }

  getBreadCrumb(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BREADCRUMB, {
      params: body
    });
  }
  getBreadCrumbQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BREADCRUMB_Qjet, {
      params: body
    });
  }
  getBreadCrumbFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BREADCRUMB_FAHES, {
      params: body
    });
  }

  getTeamMembers(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TEAM_MEMBERS, {
      params: body
    });
  }
  getTeamMembersErm(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TEAM_MEMBERS_ERM, {
      params: body
    });
  }

  getAutoCarePromotions(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_AUTOCARE_PROMOTIONS, {
      params: body
    });
  }

  getAboutus(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_ABOUTUS, {
      params: body
    });
  }

  getOurLeaderShip(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getOurLeaderShip, {
      params: body
    });
  }

  getOurLeaderShipQJET(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.QJETgetOurLeaderShip, {
      params: body
    });
  }  

  getPromotionLocations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTION_LOCATIONS, {
      params: body
    });
  }

  GetKenarPropertiesImages(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetKenarPropertiesImages, {
      params: body
    });
  }

  getStations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_STATIONS, {
      params: body
    });
  }

  getPromotionStatuses(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTION_STATUSES, {
      params: body
    });
  }

  getPromotionFeaturedItems(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTIONS_FEATURED_ITEMS, {
      params: body
    });
  }

  getPromotionsList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTIONS_LIST, {
      params: body
    });
  }

  getRelatedPromotionsList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATED_PROMOTIONS_LIST, {
      params: body
    });
  }

  getRelatedNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATED_NEWS, {
      params: body
    });
  }
  getRelatedNewsFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATED_NEWS_FAHES, {
      params: body
    });
  }
  // getRelatedNewsQjet(body: any = {}): Observable<any> {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATED_NEWS_QJET, {
  //     params: body
  //   });
  // }
  getRelatedNewsQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RELATED_NEWS_QJET, {
      params: body
    });
  }

  getEventsLanding(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENTS_LANDING, {
      params: body
    });
  }


  getMultimediaImages(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_IMAGES, {
      params: body
    });
  }

  getMultimediaVideos(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_VIDEOS, {
      params: body
    });
  }

  getFahesMultimediaByType(body: any = {}, pageType: string): Observable<any> {
    return this.httpClient.get<any>(pageType === 'video' ? CMS_END_POINTS.GET_FAHES_MULTIMEDIA_VIDEOS : pageType === 'photo' ? CMS_END_POINTS.GET_FAHES_MULTIMEDIA_IMAGES : CMS_END_POINTS.GET_FAHES_MULTIMEDIA_GALLERIES, {
      params: body
    });
  }
  getQjetMultimediaByType(body: any = {}, pageType: string): Observable<any> {
    return this.httpClient.get<any>(pageType === 'video' ? CMS_END_POINTS.GET_QJET_MULTIMEDIA_VIDEOS : pageType === 'photo' ? CMS_END_POINTS.GET_QJET_MULTIMEDIA_IMAGES : CMS_END_POINTS.GET_QJET_MULTIMEDIA_GALLERIES, {
      params: body
    });
  }

  getGalleriesListing(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_MULTIMEDIA_GALLERIES, {
      params: body
    });
  }

  getWoqodeTimeline(body: any = {}, tabKey: string): Observable<any> {
    const apiURL = tabKey === "corporate" ? CMS_END_POINTS.GET_WOQODE_INDIVIDUAL_COORPORATE_TIMELINE : CMS_END_POINTS.GET_WOQODE_TIMELINE;
    return this.httpClient.get<any>(apiURL, {
      params: body
    });
  }

  getBusinessWithWoqodProducts(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BUSINESS_WITH_WOQOD_PRODUCTS, {
      params: body
    });
  }

  getTopUpSteps(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TOP_UP_STEPS, {
      params: body
    });
  }

  getBecomeASupplierMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBecomeASupplierMeta, {
      params: body
    });
  }
  getBecomeASupplierMetaAutoCare(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBecomeASupplierMetaAuto, {
      params: body
    });
  }
  getBecomeASupplierMetaGenral(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBecomeASupplierMetaGenral, {
      params: body
    });
  }

  getRetailPrices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RETAIL_PRICES, {
      params: body
    });
  }

  getRetailPricesPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RETAIL_PRICES, {
      params: body
    }).toPromise();
  }

  getErmBullets(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BULLETS_ERM, {
      params: body
    });
  }
  getErmContent(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_PAGE_ERM, {
      params: body
    });
  }
  getFuelPrices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.FUEL_PRICE_YEAR, {
      params: body
    });
  }

  getErmData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DATA_ERM, {
      params: body
    });
  }

  getJobs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_JOBS, {
      params: body
    });
  }
  getSearchItem(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SEARCH_ITEM, {
      params: body
    });
  }
  getSearchFahes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SEARCH_FAHES, {
      params: body
    });
  }
  getSearchQjet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SEARCH_QJET, {
      params: body
    });
  }
  getLubricants(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANT_LANDING, {
      params: body
    });
  }
  getLubricantsCarsoul(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANT_CARSOUL_LANDING, {
      params: body
    });
  }
  getLubricantsMeta(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANT_LANDING_META, {
      params: body
    });
  }

  getSiteUserDeactivateReasons(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getSiteUserDeactivateReasons, {
      params: body
    });
  }

  getAutoCareSubServicesPricingCategory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getAutoCareSubServicesPricingCategory, {
      params: body
    });
  }

      getPrices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getPrices, {
      params: body
    });
  }  

  getTags(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_JOB_STAGS, {
      params: body
    });
  }

  getJobsCodes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_JOBS_CODES, {
      params: body
    });
  }
  getSalaryConfig(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SALAY_CONFIG, {
      params: body
    });
  }
  getCareerLocations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_LOCATIONS, {
      params: body
    });
  }

  getCareerDepartments(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_DEPARTMENTS, {
      params: body
    });
  }
  getCareerSubssdaires(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CAREER_SUBSIDAIRES, {
      params: body
    });
  }

  getPromotionsRetail(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RETAIL_PROMOTIONS, {
      params: body
    });
  }

  getAutoCareSubServices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_AUTO_CARE_SUB_SERVICES, {
      params: body
    });
  }

  getMapData(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getMapData, {
      params: body
    });
  }

  getMapDataNew(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getMapDataNew, {
      params: body
    });
  }

  getMapDataNewPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.getMapDataNew, {
      params: body
    }).toPromise();
  }

  getStationTypes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getStationTypes, {
      params: body
    });
  }

  getStationTypesPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.getStationTypes, {
      params: body
    }).toPromise();
  }

  GetAllWorkingHoursTypes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetAllWorkingHoursTypes, {
      params: body
    });
  }

  GetAllWorkingHoursTypesPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.GetAllWorkingHoursTypes, {
      params: body
    }).toPromise();
  }

  getListCategorySupplier(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_LIST_CATEGORY_SUPPLIER, {
      params: body
    });
  }

  GetSupplierRequestProductCategory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetSupplierRequestProductCategory, {
      params: body
    });
  }

  getDashboardAppointmentHistory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DASHBOARD_APPOINTMENT_HISTORY, {
      params: body
    });
  }
  getDashboardWalletHistory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DASHBOARD_WALLET_HISTORY, {
      params: body
    });
  }
  getDashboardWalletTopupHistory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DASHBOARD_WALLET_TOPUP_HISTORY, {
      params: body
    });
  }

  getWoqodHelpAreas(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodHelpAreas, {
      params: body
    });
  }

  getDashboardAppointmentHistoryByID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getDashboardAppointmentHistoryByID, {
      params: body
    });
  }



  getMyVehicle(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getMyVehicle, {
      params: body
    });
  }

  GetSiteUserVehiclesPlateTypes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetSiteUserVehiclesPlateTypes, {
      params: body
    });
  }

  getSiteUserWalletAmmount(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getSiteUserWalletAmmount, {
      params: body
    });
  }

  // async getUserByTokenPromise(body: any = {}) {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_USER_DETAILS_BY_TOKEN, {
  //     params: body
  //   }).toPromise();
  // }

  getFahesNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_NEWS_MEDIA_CENTER, {
      params: body
    });
  }
  getQjetNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_NEWS_MEDIA_CENTER, {
      params: body
    });
  }
  getAmountOfWallet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_AMOUNT_OF_WALLET, {
      params: body
    });
  }

  getFahesEvents(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_EVENTS, {
      params: body
    });
  }
  getQJETEvents(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_QJET_EVENTS, {
      params: body
    });
  }

  getMilestones(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_MILESTONES, {
      params: body
    });
  }

  getKenarProperties(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_KENAR_PROPERTIES, {
      params: body
    });
  }

  getKenarHeroSlider(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_KENAR_SLIDER, {
      params: body
    });
  }

  deleteAccount(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.deleteAccount, body);
  }

  requestAutoCareSupplier(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.REQUEST_AUTO_CARE_AUPPLIER, body);
    // {
    //   "autoCareSupplierRequestID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "qid": 0,
    //   "email": "string",
    //   "supplierName": "string",
    //   "contactPerson": "string",
    //   "autoCareService": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "productDescription": "string",
    //   "crNumber": "string",
    //   "crStartDate": "2023-08-25T10:39:17.704Z",
    //   "crEndDate": "2023-08-25T10:39:17.704Z",
    //   "companyProfile": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "cr": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "tradeLincense": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "taxCard": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "declaration": "string",
    //   "loackedOn": "2023-08-25T10:39:17.704Z",
    //   "createdBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "createdByName": "string",
    //   "modifiedByName": "string",
    //   "lockedByName": "string"
    // }
  }
  requestEtagGenralInformation(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.GET_E_TAG_GENRAL_INFORMATION, body);
    // {
    //   "autoCareSupplierRequestID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "qid": 0,
    //   "email": "string",
    //   "supplierName": "string",
    //   "contactPerson": "string",
    //   "autoCareService": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "productDescription": "string",
    //   "crNumber": "string",
    //   "crStartDate": "2023-08-25T10:39:17.704Z",
    //   "crEndDate": "2023-08-25T10:39:17.704Z",
    //   "companyProfile": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "cr": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "tradeLincense": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "taxCard": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "declaration": "string",
    //   "loackedOn": "2023-08-25T10:39:17.704Z",
    //   "createdBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "createdByName": "string",
    //   "modifiedByName": "string",
    //   "lockedByName": "string"
    // }
  }

  subscripeToTenderAlerts(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.SUBSCRIPE_TO_TENDER_ALERTS, body);
    // {
    //   "tendersAlertEmailID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "entityId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "titleAR": "string",
    //   "titleEN": "string",
    //   "subjectAR": "string",
    //   "subjectEN": "string",
    //   "fromEmail": "string",
    //   "emailBodyAR": "string",
    //   "emailBodyEN": "string",
    //   "createdOn": "2023-08-25T10:41:42.041Z",
    //   "modifiedOn": "2023-08-25T10:41:42.041Z",
    //   "loackedOn": "2023-08-25T10:41:42.041Z",
    //   "createdBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "modifiedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "lockedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
    // }
  }
  fahesFeedback(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.GET_FAHES_FEEDBACK, body, httpOptions);
    //   curl -X 'POST' \
    // 'http://20.173.96.73:8080/InsertFeedback' \
    // -H 'accept: text/plain' \
    // -H 'Content-Type: multipart/form-data' \
    // -F 'TitleEN=xcvxcvcxvcxv' \
    // -F 'SectorID=xxcvxcvxcxv' \
    // -F 'TitleAR=xcvxcvxcxcv' \
    // -F 'MobileNumber=xcvcxvcvxcxv' \
    // -F 'EmailAddress=xcvxcvxcv' \
    // -F 'CategoryID=xcvcvxxxvc' \
    // -F 'FullName=xvcxvvxcvxc' \
    // -F 'Company=xcvxcvxvc' \
    // -F 'Comment=xcvcxvcvxcxv'

  }
  tenderDocument(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.GET_TENDER_DOCUMENT, body);
    //   curl -X 'POST' \
    // 'http://20.173.96.73:8080/InsertFeedback' \
    // -H 'accept: text/plain' \
    // -H 'Content-Type: multipart/form-data' \
    // -F 'TitleEN=xcvxcvcxvcxv' \
    // -F 'SectorID=xxcvxcvxcxv' \
    // -F 'TitleAR=xcvxcvxcxcv' \
    // -F 'MobileNumber=xcvcxvcvxcxv' \
    // -F 'EmailAddress=xcvxcvxcv' \
    // -F 'CategoryID=xcvcvxxxvc' \
    // -F 'FullName=xvcxvvxcvxc' \
    // -F 'Company=xcvxcvxvc' \
    // -F 'Comment=xcvcxvcvxcxv'

  }
  careerJob(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.GET_CAREER_JOB, body, httpOptions);
    //   curl -X 'POST' \
    // 'http://20.173.96.73:8080/InsertFeedback' \
    // -H 'accept: text/plain' \
    // -H 'Content-Type: multipart/form-data' \
    // -F 'TitleEN=xcvxcvcxvcxv' \
    // -F 'SectorID=xxcvxcvxcxv' \
    // -F 'TitleAR=xcvxcvxcxcv' \
    // -F 'MobileNumber=xcvcxvcvxcxv' \
    // -F 'EmailAddress=xcvxcvxcv' \
    // -F 'CategoryID=xcvcvxxxvc' \
    // -F 'FullName=xvcxvvxcvxc' \
    // -F 'Company=xcvxcvxvc' \
    // -F 'Comment=xcvcxvcvxcxv'

  }
  SupplierFom(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.GET_SUPPLIER_FORM, body, httpOptions);
    //   curl -X 'POST' \
    // 'http://20.173.96.73:8080/InsertFeedback' \
    // -H 'accept: text/plain' \
    // -H 'Content-Type: multipart/form-data' \
    // -F 'TitleEN=xcvxcvcxvcxv' \
    // -F 'SectorID=xxcvxcvxcxv' \
    // -F 'TitleAR=xcvxcvxcxcv' \
    // -F 'MobileNumber=xcvcxvcvxcxv' \
    // -F 'EmailAddress=xcvxcvxcv' \
    // -F 'CategoryID=xcvcvxxxvc' \
    // -F 'FullName=xvcxvvxcvxc' \
    // -F 'Company=xcvxcvxvc' \
    // -F 'Comment=xcvcxvcvxcxv'

  }

  becomeARetailSupplier(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };

    return this.httpClient.post<any>(CMS_END_POINTS.SUBMIT_BECOME_RETAIL_SUPPLIER, body, httpOptions);
  }
  submitInterestInLeasingProperty(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.SUBMIT_INTEREST_INLEASING_PROPERTY, body, httpOptions);
  }

  subscribeToTenderAlerts(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.SUBSCRIPE_TENDER_ALERTS, body, httpOptions);
  }

  // 

  getHomepage(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE, {
      params: body
    });
  }

  getHomePageSlider(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_SLIDER, {
      params: body
    });
  }

  getHomePageSliderQJET(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_SLIDERQJET, {
      params: body
    });
  }  

  getHomePageNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_NEWS, {
      params: body
    });
  }

  QJETgetHomePageNews(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.QJETgetHomePageNews, {
      params: body
    });
  }  

  getHomePagePromotions(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_PROMOTIONS, {
      params: body
    });
  }

  getHomePageTenders(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_TENDERS, {
      params: body
    });
  }
  getTendersTable(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TENDERS_TABLE, {
      params: body
    });
  }

  getHomePageSocialmedia(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_SOCIALMEDIA, {
      params: body
    });
  }
  getHomePageWoqodApp(body: any = {}, headers: any = {}): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders(headers),
    };
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_WOQOD_APP, httpOptions);
  }


  getHomePageProductsAndServices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_HOMEPAGE_PRODUCTS_SERVICES, {
      params: body
    });
  }

  QJETgetHomePageProductsAndServices(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.QJETgetHomePageProductsAndServices, {
      params: body
    });
  }

  getFaqWoqode(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_WOQODE_FAQ, {
      params: body
    });
  }

  getSidraPromotios(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SIDRA_PROMOTIONS, {
      params: body
    });
  }

  getSidraOrders(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SIDRA_ORDERS, {
      params: body
    });
  }
  getFAQ(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAQ_CATEGORIES, {
      params: body
    });
  }
  getDataBCM(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DATA_BCM, {
      params: body
    });
  }
  getContentPageBCM(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DATA_ARRE_TWO, {
      params: body
    });
  }
  getContentPageCSR(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_CONTENT_CSR, {
      params: body
    });
  }
  getBulletsBCM(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BULLETS_BCM, {
      params: body
    });
  }
  getEventsBCM(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENTS_BCM, {
      params: body
    });
  }
  getEventsCSR(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_EVENTS_CSR, {
      params: body
    });
  }
  getStickyIcons(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_STICKY_ICONS, {
      params: body
    });
  }
  getStaticMessage(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_STATIC_MESSAGE_PAYMENT_SUCCESS, {
      params: body
    });
  }
  getRentShopValidate(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RENT_SHOP_VALIDATE, {
      params: body
    });
  }
  getCategoryListRentShop(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_RENT_SHOP_BUSINESS_CATEGOTY, {
      params: body
    });
  }
  getRentShopCategoryList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_BUSINESS_CATEGORY, {
      params: body
    });
  }
  getNumberOfShopRList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SHOPS_CATEGORY, {
      params: body
    });
  }
  getStationList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_STATION_CATEGORY, {
      params: body
    });
  }
  getSubSitesList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUBSITE_LIST, {
      params: body
    });
  }

  getPropertyId(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROPERTY_ID, {
      params: body
    });
  }

  getKenarPropertyByID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_KENAR_PROPERTY_ID, {
      params: body
    });
  }

  getTenderStatus(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_STATUS_TENDERS, {
      params: body
    });
  }
  getSuperMarketTable(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUPER_MARKET_TABLE, {
      params: body
    });
  }
  getTrafficeServiceTable(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_TRAFFICE_SERVICE_TABLE, {
      params: body
    });
  }
  getSuperMarketRetailersTable(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SUPER_MARKET_RETAILERS_TABLE, {
      params: body
    });
  }
  getSliderProductandService(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SLIDER_PRODUCT_AND_SERVICE, {
      params: body
    });
  }
  getPromotionsProductandSerive(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PROMOTIONS_PRODUCT_AND_SERVICE, {
      params: body
    });
  }
  getFahesHomePageSerive(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FAHES_HOMEPAGE_SERVICE, {
      params: body
    });
  }
  getDataProductandSerive(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_DATA_PRODUCT_AND_SERVICE, {
      params: body
    });
  }
  getProductListProductandSerive(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_PRODUCT_LIST_PRODUCT_AND_SERVICE, {
      params: body
    });
  }
  getServiceListProductandSerive(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_SERVICE_LIST_PRODUCT_AND_SERVICE, {
      params: body
    });
  }

  QJETGetByQjetServicesDetailService(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.QJETGetByQjetServicesDetailService, {
      params: body
    });
  }

  GetQjetHomeFAQs(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetQjetHomeFAQs, {
      params: body
    });
  }  

  getYears(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_YEARS, {
      params: body
    });
  }

  updateUserProfile(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.updateUserProfile, body);
    // {
    //   "autoCareSupplierRequestID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "qid": 0,
    //   "email": "string",
    //   "supplierName": "string",
    //   "contactPerson": "string",
    //   "autoCareService": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "productDescription": "string",
    //   "crNumber": "string",
    //   "crStartDate": "2023-08-25T10:39:17.704Z",
    //   "crEndDate": "2023-08-25T10:39:17.704Z",
    //   "companyProfile": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "cr": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "tradeLincense": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "taxCard": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "declaration": "string",
    //   "loackedOn": "2023-08-25T10:39:17.704Z",
    //   "createdBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "createdByName": "string",
    //   "modifiedByName": "string",
    //   "lockedByName": "string"
    // }
  }

  getUserFlags(body: any = {}, flagName: string): Observable<any> {

    // 
    // 
    let params = `?SiteUsersID=${body.SiteUsersID}&Status=${body.Status}`;

    let END_POINT = '';
    if (flagName === 'sendBookingConfirmationNotification') END_POINT = CMS_END_POINTS.sendBookingConfirmationNotification;
    else if (flagName === 'sendBookingChangedNotification') END_POINT = CMS_END_POINTS.sendBookingChangedNotification;
    else if (flagName === 'sendOrderDeliveredNotification') END_POINT = CMS_END_POINTS.sendOrderDeliveredNotification;
    else if (flagName === 'sendEmailNotification') END_POINT = CMS_END_POINTS.sendEmailNotification;
    else if (flagName === 'sendSMS') END_POINT = CMS_END_POINTS.sendSMS;
    // 
    END_POINT += params;
    // 
    return this.httpClient.post<any>(END_POINT, {});
    // return this.httpClient.post<any>(END_POINT, {
    //   params: body
    // });
  }

  getUserByToken(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_USER_DETAILS_BY_TOKEN, {
      params: body
    });
  }

  fakeAPI(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.FAKE_API, {
      params: body
    });
  }

  getHeader(body: any = {}, lang: string = '', pageType: string): Observable<any> {
    const fahesEndpoint = lang === 'en' ? CMS_END_POINTS.GET_HEADER_FAHES : CMS_END_POINTS.GET_HEADER_AR_FAHES;
    const woqodEndpoint = lang === 'en' ? CMS_END_POINTS.GET_HEADER : CMS_END_POINTS.GET_HEADER_AR;
    const qjetEndpoint = lang === 'en' ? CMS_END_POINTS.GET_HEADERQJET : CMS_END_POINTS.GET_HEADER_ARQJET;
    // 
    return this.httpClient.get<any>(pageType === 'fahes' ? fahesEndpoint : pageType === 'qjet' ? qjetEndpoint : woqodEndpoint, {
      params: body
    });
  }

  getHeaderHelper(body: any = {}, pageType: string): Observable<any> {
    return this.httpClient.get<any>(pageType === 'fahes' ? CMS_END_POINTS.getHeaderHelperFahes : pageType === 'qjet' ? CMS_END_POINTS.getHeaderHelperQJET : CMS_END_POINTS.getHeaderHelper, {
      params: body
    });
  }

  getLoginBnanners(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getLoginBanners, {
      params: body
    });
  }

  getFooter(body: any = {}, lang: string = '', pageType: string): Observable<any> {
    const fahesEndpoint = lang === 'en' ? CMS_END_POINTS.GET_FOOTER_Fahes : CMS_END_POINTS.GET_FOOTER_AR_Fahes;
    const woqodEndpoint = lang === 'en' ? CMS_END_POINTS.GET_FOOTER : CMS_END_POINTS.GET_FOOTER_AR;
    const qjetEndpoint = lang === 'en' ? CMS_END_POINTS.GET_FOOTERQJET : CMS_END_POINTS.GET_FOOTER_ARQJET;

    return this.httpClient.get<any>(pageType === 'fahes' ? fahesEndpoint : pageType === 'qjet' ? qjetEndpoint : woqodEndpoint, {
      params: body
    });
  }

  getFooterBottom(body: any = {}, lang: string = '', pageType: string): Observable<any> {
    const fahesEndpoint = lang === 'en' ? CMS_END_POINTS.getFooterBottomFahes : CMS_END_POINTS.GET_FOOTER_AR_Fahes;
    const woqodEndpoint = lang === 'en' ? CMS_END_POINTS.getFooterBottom : CMS_END_POINTS.GET_FOOTER_AR;
    const qjetEndpoint = lang === 'en' ? CMS_END_POINTS.getFooterBottomQJET : CMS_END_POINTS.GET_FOOTER_ARQJET;

    return this.httpClient.get<any>(pageType === 'fahes' ? fahesEndpoint : pageType === 'qjet' ? qjetEndpoint : woqodEndpoint, {
      params: body
    });
  }

  getInvestorRelationsMeta(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_INVESTOR_RELATIONS_DATA, {
      params: body
    });
  }

  getInvestorRelationsDetailsMeta(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_INVESTOR_RELATIONS_DETAILS, {
      params: body
    });
  }

  // getLubricants(body: any = {}): Observable<any> {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANTS_LANDING, {
  //     params: body
  //   });
  // }

  // getFeaturedLubricants(body: any = {}): Observable<any> {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANTS_FEATURED, {
  //     params: body
  //   });
  // }

  // getFeaturedProducts(body: any = {}): Observable<any> {
  //   return this.httpClient.get<any>(CMS_END_POINTS.GET_LUBRICANTS_FEATURED_PRODUCTS, {
  //     params: body
  //   });
  // }

  async validateMerchantServer(body: any = {}) {
    return this.httpClient.post<any>(CMS_END_POINTS.CREATE_APPLE_SESSION, {
      params: body
    }).toPromise();
  }
 
  getCurrentBalance(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.currentBalance, {
      params: body
    });
  }
    SavePaymentCard(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.SavePaymentCard, {
      params: body
    });
  }

  getTopUpsHistory(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.topUpsHistory, {
      params: body
    });
  }

  getTransactionHistory(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.transactionHistory, {
      params: body
    });
  }

  getUserVehiclesForTransactionHistory(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getUserVehiclesForTransactionHistory, {
      params: body
    });
  }

  getFuelTransactions(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetTransactionHistory_Web, {
      params: body
    });
  }

  getVehiclesForFuelTransactions(body: any = {},): Observable<any> {
    // mock
    // return of([{
    //   fleetCode: 'F001',
    //   licensePlateNr: 'ABC123'
    // }]);
    return this.httpClient.get<any>(CMS_END_POINTS.GetUserVehiclesForTransactionHistoryNew, {
      params: body
    });
  }
  
  getTopupTransaction(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetTopupTransactionHistory, {
      params: body
    });
  }

  getAccountTransactionHistory(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getTransactionHistory, {
      params: body
    });
  }

  getUserCards(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getUserCards, {
      params: body
    });
  }

  getPaymentModule(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getPaymentModule, {
      params: body
    });
  }

  getTokenByRefreshToken(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getTokenByRefreshToken, {
      params: body
    });
  }

  deleteUserCard(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.deleteUserCard, {
      params: body
    });
  }

  getCyberSourcePaymentInquireTransactionStatus(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.CyberSourcePaymentInquireTransactionStatus_local, {
      params: body
    });
  }

  getWoqodSettings(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.WoqodSettingsSettings, {
      params: body
    });
  }

  walletTransactionHistory(body: any = {},): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.WalletTransactionHistory, {
      params: body
    });
  }

  topupPay(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.topupPay, {
      params: body
    });
  }

  cybersourceApplePayInitiate(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.CybersourceApplePayInitiate, {
      params: body
    });
  }

  cybersourceApplePayTransaction(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.CybersourceApplePayTransaction, {
      params: body
    });
  }


  // 
  registerUserPhone(body: any = {}, ReCaptchaToken: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 
        ReCaptchaToken: ReCaptchaToken
       }),
      params: body
    };    
    return this.httpClient.get<any>(CMS_END_POINTS.RegisterUserPhone, httpOptions);
  }
  registerUserEmail(body: any = {}): Observable<any> {
    // https://md.woqod.com/FrontOffice
    // remove front office
    return this.httpClient.post<any>("WOQOD_APIS_BASE" + CMS_END_POINTS.RegisterUserEmail, body);
  }
  SendEmailOtp(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.SendEmailOtp, body);
  }

  validateOTPPhone(body: any = {}, ReCaptchaToken: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 
        ReCaptchaToken: ReCaptchaToken
       }),
      params: body
    };    
    return this.httpClient.get<any>(CMS_END_POINTS.ValidateOTPPhone, httpOptions);
  }

    VerifyEmailOtp(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.VerifyEmailOtp, body);
  }

  getTokenByB2C(body: any = {},headers: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetTokenByB2C, {
      headers: new HttpHeaders(headers),
      params: body
    });
  }


  getProfileByToken(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getProfileByToken, {
      params: body
    });
  }
  

  // 
  // 
  // 
  getInspectionSettings(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getwoqodInspectionSettings, { params: body });
  }
  
  getAppointmentsPaginationByUserID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getAppointmentsPaginationByUserID, { params: body });
  }
  
  getUserUnUsedPaymentTransactions(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getUserUnUsedPaymentTransactions, { params: body });
  }
  
  getWoqodPlateTypes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getWoqodPlateTypes, { params: body });
  }
  
  getVehiclesWithNoAppointments(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getVehiclesWithNoAppointments, { params: body });
  }
  
  validateVehicleForBooking(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.validateVehicleForBooking, { params: body });
  }
  
  getEligableStations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getEligableStations, { params: body });
  }
  
  getServicesByStationID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getServicesByStationID, { params: body });
  }

  getServicesWoqod(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getServicesWoqod, { params: body });
  }  

  getServicesWoqodNew(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getServicesWoqodNew, { params: body });
  }

  getFullyBookedDatesWoqod(isAPCPage: boolean, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.getFullyBookedDatesWoqod, { params: body }) : this.GetWoqodEFullyBookedDates(body);
  }
  
  getFullyBookedDates(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getFullyBookedDates, { params: body });
  }
  
  getStationOffDates(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getStationOffDates, { params: body });
  }
  
  getVehiclesWithUsedPayments(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getVehiclesWithUsedPayments, { params: body });
  }
  
  validateVehicleForPaymnet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.validateVehicleForPaymnet, { params: body });
  }
  
  getWalkinStations(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getWalkinStations, { params: body });
  }
  
  getInspectionPrice(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getInspectionPrice, { params: body });
  }
  
  isExpiring(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.isExpiring, { params: body });
  }
  
  addUserVehicles(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.addUserVehicles, body);
  }
  
  listUserVehicles(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehicles, { params: body });
  }

  listUserVehiclesRetail(body: any = {}): Observable<any> {
    body['pageSize'] = "500";
    body['pageNumber'] = "1";    
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehiclesRetail, { params: body })
    .pipe(map(response => response.pageItems));
  }  

  listUserVehiclesWoqode(body: any = {}): Observable<any> {
    body['pageSize'] = "500";
    body['pageNumber'] = "1";
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehiclesWoqode, { params: body })
    .pipe(map(response => response.pageItems));
  }

  listUserVehiclesRetailPaginated(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehiclesRetail, { params: body });
  }  
  
  listUserVehiclesWoqodePaginated(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehiclesWoqode, { params: body });
  }

  listUserVehiclesPaginated(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.listUserVehiclesPaginated, { params: body });
  }  
  
  getAvailableSlots(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getAvailableSlots, { params: body });
  }
  
   validateVehicleInfo(isAPCPage: boolean, body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.validateVehicleInfo, { params: body });
  }
  
  updateBooking(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.updateBooking, body);
  }
  
  saveBooking(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.saveBooking, body);
  }
  
  getBookingFullInfo(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBookingFullInfo, { params: body });
  }
  
  cancelAppointment(body: any = {}): Observable<any> {
    return this.httpClient.post<any>(CMS_END_POINTS.cancelAppointment, body);
  }
  
  getInspectionReport(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getInspectionReport, { params: body });
  }
  
  getPaymentTransactionsByTransactionID(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getPaymentTransactionsByTransactionID, { params: body });
  }
  
  deleteSiteUserVehicles(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.deleteSiteUserVehicles, { params: body });
  }
  
  validateVehicleInfoForPaymnet(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.validateVehicleInfoForPaymnet, { params: body });
  }
  
  validateVehicleInfoForBooking(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.validateVehicleInfoForBooking, { params: body });
  }

  getWoqodPlateTypesShapes(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodPlateTypesShapes, { params: body });
  }

  
  generatePDFFromHTML(body: any = {}): Observable<any> {
    return this.httpClient.post(CMS_END_POINTS.generatePDFFromHTML, body, {
      responseType: 'blob'
    });
  }

  setAppointmentToZero(body: any = {}): Observable<any> {
    return this.httpClient.get(CMS_END_POINTS.setAppointmentToZero, { params: body });
  }

  // 
  getSiteUserVehiclesWithUpcomingAppointments(isAPCPage: boolean, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetSiteUserVehiclesWithUpcomingAppointments, { params: body }) : this.GetSiteUserVehiclesWithUpcomingWoqodEAppointments(body);
  }

  getRetailStations(isAPCPage: boolean,  body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetRetailStations, { params: body }) : this.GetWoqodEStations(body);
  }

  getImageMapPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.getMapImage, { params: body }).toPromise();
  }

  getRetailStationsUpcomingOffDays(isAPCPage: boolean, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetRetailStationsUpcomingOffDays, { params: body }) : this.GetWoqodEStationsUpcomingOffDays(body);
  }

  getRetailStationsUpcomingOffDaysPromise(isAPCPage: boolean, body: any = {}) {
    return (isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetRetailStationsUpcomingOffDays, { params: body }) : this.GetWoqodEStationsUpcomingOffDays(body)).toPromise();
  }  

  getSlotsWithCapacity(isAPCPage: boolean, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetSlotsWithCapacity, { params: body }) : this.GetWoqodESlotsWithCapacity(body);
  }


  saveBookingAPC(isAPCPage: boolean, body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return isAPCPage ? this.httpClient.post<any>(CMS_END_POINTS.AddNewRetailAppointments, body, httpOptions) : this.AddNewWoqodEAppointments(body, httpOptions);
  }

  updateBookingAPC(isAPCPage: boolean, body: any = {}, id:string, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };    
    return isAPCPage ? this.httpClient.post<any>(CMS_END_POINTS.UpdateRetailAppointments + `/${id}`, body, httpOptions) : this.UpdateWoqodEAppointments(body, id, httpOptions);
  }

  GetRetailAppointmentsById(isAPCPage: boolean = false, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.GetRetailAppointmentsById, { params: body }) : this.GetWoqodEAppointmentsById(body);
  }

  getRetailStationsAvailableDates(isAPCPage: boolean, body: any = {}): Observable<any> {
    return isAPCPage ? this.httpClient.get<any>(CMS_END_POINTS.getRetailStationsAvailableDates, { params: body }) : this.GetWoqodEStationsAvailableDates(body);
    // 
  }
  
  confirmRetailAppointments(isAPCPage: boolean, body: any = {}, captchaToken: string = '', retailAppointmentsID: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return isAPCPage ? this.httpClient.post<any>(CMS_END_POINTS.ConfirmRetailAppointments + `?retailAppointmentsID=${retailAppointmentsID}`, body, httpOptions) : this.ConfirmWoqodEAppointments(body, retailAppointmentsID, httpOptions);
  }

  // 
  getRetailAppointmentsHistory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetRetailAppointmentsHistory, { params: body });
  }
  
  getRetailAppointmentsHistoryUpcomming(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetRetailAppointmentsHistoryupcomming, { params: body });
  }  

  getRetailAppointmentsHistoryUpcommingPromise(body: any = {}) {
    return this.httpClient.get<any>(CMS_END_POINTS.GetRetailAppointmentsHistoryupcomming, { params: body }).toPromise();
  }    
  
  cancelRetailAppointments(body: any = {}, captchaToken: string = '', retailAppointmentsID: string = '', isUpdatePage: boolean = false): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>((isUpdatePage ? CMS_END_POINTS.CancelRetailAppointmentsUpdate : CMS_END_POINTS.CancelRetailAppointments) + `?retailAppointmentsID=${retailAppointmentsID}`, body, httpOptions);
  }

  getERMLandingPageById(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.eRMLandingPageById, { params: body });
  }

  getBenefaciaryList(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBenefaciaryList, { params: body });
  }

  getBenefaciaryListPagination(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBenefaciaryListPagination, { params: body });
  }


  removeBenefaciary(body: any = {}, captchaToken: string = ''): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.removeBenefaciary, {params: body, 
      // headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    });
  }


  addBenefaciary(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.addBenefaciary, body, httpOptions);
  }

  getBenefaciaryDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.getBenefaciaryDetails, { params: body });
  }


  updateBenefaciaryLimit(body: any = {}, bodyURL: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.updateBenefaciaryLimit + `?Id=${bodyURL.Id}&OTP=${bodyURL.OTP}&limit=${bodyURL.limit}`, body, httpOptions);
  }

  retailBeneficiarySendOTP(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.retailBeneficiarySendOTP, { params: body });
  }

  GetAccountBalance(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetAccountBalance, { params: body });
  }

  GetBeneficiaryUserBalanceDetails(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GetBeneficiaryUserBalanceDetails, { params: body });
  }

    GetWoqodEStations(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodEStations, { params: body });
    }

    GetWoqodEFullyBookedDates(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodEFullyBookedDates, { params: body });
    }

    GetWoqodEStationsUpcomingOffDays(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodEStationsUpcomingOffDays, { params: body });
    }

    GetSiteUserVehiclesWithUpcomingWoqodEAppointments(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetSiteUserVehiclesWithUpcomingWoqodEAppointments, { params: body });
    }

    GetUpcomingETagAppointments(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetUpcomingETagAppointments, { params: body });
    }

    GetWoqodEStationsAvailableDates(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodEStationsAvailableDates, { params: body });
    }

    GetWoqodESlotsWithCapacity(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodESlotsWithCapacity, { params: body });
    }

    ValidateVehicleForWoqodEBooking(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.ValidateVehicleForWoqodEBooking, { params: body });
    }

    ValidateVehicleForWoqodEBookingAPC(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.ValidateVehicleForWoqodEBookingAPC, { params: body });
    }    

    GetETagAppointmentsHistory(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetETagAppointmentsHistory, { params: body });
    }

    GetETagAppointmentsHistoryPromise(body: any = {}) {
      return this.httpClient.get<any>(CMS_END_POINTS.GetETagAppointmentsHistory, { params: body }).toPromise();
    }    


    async getAppointmentEnabilityStatus(body: any = {}) {
      try{
        const response = await this.httpClient.get<any>(CMS_END_POINTS.getAppointmentEnabilityStatus, { params: body }).toPromise();
        const isWebApcEnabled = ((response?.isWebApcEnabled || '').toString()).toLowerCase();
        const isWebWoqodeEnabled = ((response?.isWebWoqodeEnabled || '').toString()).toLowerCase();
        return {
          isAPCenabled: isWebApcEnabled === 'true',
          isWOQODEenabled: isWebWoqodeEnabled === 'true'
        }
      }catch{
        return {
          isAPCenabled: false,
          isWOQODEenabled: false
        }
      }
    }

    GetETagAppointmentsHistoryNotUpcoming(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetETagAppointmentsHistoryNotUpcoming, { params: body });
    }    

    GetWoqodEAppointmentsById(body: any = {}): Observable<any> {
      return this.httpClient.get<any>(CMS_END_POINTS.GetWoqodEAppointmentsById, { params: body });
    }    


    AddNewWoqodEAppointments(body: any = {}, httpOptions: any): Observable<any> {
      return this.httpClient.post<any>(CMS_END_POINTS.AddNewWoqodEAppointments, body, httpOptions);
    }

    UpdateWoqodEAppointments(body: any = {}, id:string, httpOptions: any): Observable<any> {
      return this.httpClient.post<any>(CMS_END_POINTS.UpdateWoqodEAppointments + "/" + id, body, httpOptions);
    }
    
    ConfirmWoqodEAppointments(body: any = {}, retailAppointmentsID:any, httpOptions:any): Observable<any> {
      return this.httpClient.post<any>(CMS_END_POINTS.ConfirmWoqodEAppointments+"?retailAppointmentsID=" + retailAppointmentsID, body, httpOptions);
    }

    CancelWoqodEAppointments(body: any = {}, captchaToken: string = '', retailAppointmentsID: string = '', isUpdatePage: boolean = false): Observable<any> {
      const httpOptions = {
        headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
      };
      return this.httpClient.post<any>((isUpdatePage ? CMS_END_POINTS.CancelWoqodEAppointmentsUpdate : CMS_END_POINTS.CancelWoqodEAppointments) + `?retailAppointmentsID=${retailAppointmentsID}`, body, httpOptions);
    }


          feedback(body: any = {}, captchaToken: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ ReCaptchaToken: captchaToken, 'X-Platform': 'web' })
    };
    return this.httpClient.post<any>(CMS_END_POINTS.GET_FEEDBACK, body, httpOptions);
    //   curl -X 'POST' \
    // 'http://20.173.96.73:8080/InsertFeedback' \
    // -H 'accept: text/plain' \
    // -H 'Content-Type: multipart/form-data' \
    // -F 'TitleEN=xcvxcvcxvcxv' \
    // -F 'SectorID=xxcvxcvxcxv' \
    // -F 'TitleAR=xcvxcvxcxcv' \
    // -F 'MobileNumber=xcvcxvcvxcxv' \
    // -F 'EmailAddress=xcvxcvxcv' \
    // -F 'CategoryID=xcvcvxxxvc' \
    // -F 'FullName=xvcxvvxcvxc' \
    // -F 'Company=xcvxcvxvc' \
    // -F 'Comment=xcvcxvcvxcxv'

  }

        getFeedbackCategory(body: any = {}): Observable<any> {
    return this.httpClient.get<any>(CMS_END_POINTS.GET_FEEDBACK_CATEGORY_NEW, {
      params: body
    });
  }
}
